import { $api } from '@/shared/api/axiosInstance';

type Props = {
    id: string;
};

export const getUserPhoto = async ({ id }: Props) => {
    if (!id) return;

    const url = `/api/v1/users/${id}/avatar`;
    const { data } = await $api.get(url, {
        responseType: 'arraybuffer',
    });

    const blob = new Blob([data], { type: 'image/png' });

    return await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject(new Error('Не удалось преобразовать фото в data URL'));
            }
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
